module.exports = __webpack_public_path__ + "static/media/icon-faqs-full@2x.cb6822b1.png";